import { Default } from './internal/Default';
import { Contact } from './ContactRedesign';
import { CreditMemo } from './CreditMemoRedesign';
import { CustomerSuccessAlert } from './CustomerSuccessAlertRedesign';
import { MeetingEvent } from './MeetingEventRedesign';
import { SocialProfile } from './SocialProfileRedesign';
import { Subscription } from './SubscriptionRedesign';
import { CONTACT_TYPE_ID, CREDIT_MEMO_TYPE_ID, CUSTOMER_SUCCESS_ALERT_TYPE_ID, MEETING_EVENT_TYPE_ID, SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';

// Sparse mapping - only includes objects with redesigned behaviors
const redesignExtensions = {
  [CONTACT_TYPE_ID]: Contact,
  [CREDIT_MEMO_TYPE_ID]: CreditMemo,
  [CUSTOMER_SUCCESS_ALERT_TYPE_ID]: CustomerSuccessAlert,
  [MEETING_EVENT_TYPE_ID]: MeetingEvent,
  ['0-144']: SocialProfile,
  [SUBSCRIPTION_TYPE_ID]: Subscription
};
export const getRedesignExtensions = () => redesignExtensions;
export const getRedesignDefaultExtension = () => Default;